import React from "react";

export default function Size300X600({
  banner,
  title,
  description,
  titleButton,
  colorButton,
  imageBrand,
  logoBrand,
  backgroundColorDetailsArea,
  borderRadiusButton,
}) {
  return (
    <>
      <div
        className="border border-1 d-flex flex-column justify-content-between position-relative"
        id="preview-banner"
        style={{
          width: `${banner.size.width}px`,
          height: `${banner.size.height}px`,
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            width: `${banner.cropSize.width}px`,
            height: `${banner.cropSize.height}px`,
          }}
        >
          <img
            style={{
              width: `${banner.cropSize.width}px`,
              height: `${banner.cropSize.height}px`,
            }}
            src={
              imageBrand
                ? imageBrand
                : "/assets/img/preview-image-banner-generator.svg"
            }
          />
        </div>

        <div
          style={{
            width: `${banner.descriptionSize.width}px`,
            height: `${banner.descriptionSize.height}px`,
            backgroundColor: backgroundColorDetailsArea,
          }}
          className="d-flex flex-column align-items-center pt-2 px-2"
        >
          {logoBrand && (
            <div>
              <img src={logoBrand} />
            </div>
          )}

          <div>
            <span
              className="text-break"
              style={{ fontWeight: "bold", fontSize: "1.2rem" }}
            >
              {title}
            </span>
          </div>
          <div>
            <span className="text-break">{description}</span>
          </div>
        </div>
        <div
          className="position-absolute"
          style={{
            top: `${banner.positionButton.top}px`,
            left: "50%",
            transform: "translate(-50%)",
          }}
        >
          <span
            className="btn btn-success px-2 py-1"
            id="view-button-in-preview-section"
            style={{
              height: "30px",
              backgroundColor: colorButton,
              borderColor: colorButton,
              borderRadius: `${borderRadiusButton}px`,
            }}
          >
            {titleButton ? titleButton : "مشاهده"}
          </span>
        </div>
      </div>
    </>
  );
}
